module.exports = {"pathContext":{"slug":"/it/BCJ/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-bcj.json
// module id = 730
// module chunks = 138843065278233